import { render, staticRenderFns } from "./DevolucionesAlta.vue?vue&type=template&id=24255fce&scoped=true"
import script from "./DevolucionesAlta.vue?vue&type=script&lang=js"
export * from "./DevolucionesAlta.vue?vue&type=script&lang=js"
import style0 from "./DevolucionesAlta.vue?vue&type=style&index=0&id=24255fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24255fce",
  null
  
)

export default component.exports